import { getAllWorkflows } from "@/api/workflow";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

type UseWorkflowsOptions = {
  page?: number;
  size?: number;
  search?: string;
  enabled?: boolean;
};

export const useWorkflows = ({
  page,
  size,
  search,
  enabled = true
}: UseWorkflowsOptions = {}) => {
  const [searchParams] = useSearchParams();

  const searchValue = search ?? (searchParams.get("search") || "");
  const pageValue = page ?? (Number(searchParams.get("page")) || 1);
  const sizeValue = size ?? (Number(searchParams.get("size")) || 10);

  return useQuery({
    queryFn: () => getAllWorkflows({ page: pageValue, size: sizeValue, search: searchValue }),
    queryKey: ["workflows", { page: pageValue, size: sizeValue, search: searchValue }],
    refetchOnMount: true,
    enabled
  });
};
